import React from 'react';
import classNames from 'classnames';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import { Icon } from 'ui';

const QuestionHint = ({
  isValid,
  questionType,
  isPracticeQuestion,
  isZendesk,
  hasWarning,
}) => {
  const styleName = classNames('EditorElement-hint', {
    'EditorElement-hint--valid': isValid,
  });

  const hintTypes = () => {
    if (!isValid && isPracticeQuestion) {
      return t('questions.element.disabled');
    }
    if (t(`questions.types.${questionType}`) && isZendesk) {
      return t(`questions.types.${questionType}.zendesk.hint`);
    }
    if (t(`questions.types.${questionType}`)) {
      return t(`questions.types.${questionType}.hint`);
    }

    return '';
  };

  return (
    <>
      {hasWarning ? (
        <div className={styleName}>
          <Icon name={isValid ? 'correct' : 'error'} />
          <span>{t(`questions.types.${questionType}.warning`)}</span>
        </div>
      ) : (
        <Text variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}>
          {hintTypes()}
        </Text>
      )}
    </>
  );
};

export default QuestionHint;
